<template>
  <div class="Contact">
    <HeadPageImage class="updateIconContact"
                   :title="'Contact'"
                   :subTitle="null"
                   :icon1="'contact/sms.svg'" :altIcon1="'Decoration SMS'"
                   :icon2="'contact/lettre.svg'" :altIcon2="'Decoration Letter'"
                   :img1="'contact/industrie1.jpg'" :altImg1="'Industrie 1 Image'"
                   :img2="'contact/sending.jpg'" :altImg2="'Sending Image'"
                   :img3="'contact/industrie2.jpg'" :altImg3="'Industrie2 Image'"
                   :img4="'contact/phone.jpg'" :altImg4="'Phone Image'"
    />
    <div class="Contact-Container">
      <div class="Contact-Content">
        <div class="Contact-Data">
          <div class="Top-Title">
            <p class="Green Bold">Entrez en contact !</p>
          </div>
          <div class="Middle-Content">
            <p class="Green Weight">Téléphone</p>
            <a href="tel:0482325001">
              04 82 32 50 01
            </a>
          </div>
          <div class="Middle-Content Content-Adress">
            <p class="Green Weight">Adresse</p>
            <p>230, rue Pierre Duhem <br> 13 290 Aix en Provence</p>
          </div>
          <div class="Middle-Content">
            <p class="Green Weight">Email</p>
            <a href="mailto:contact@jobstream.fr">
              contact@jobstream.fr
            </a>
          </div>
          <div class="Bottom-Title">
            <img src="/img/contact/envoyer.svg" alt="Icon Envoyer"/>
            <p class="Green Bold">Nous répondrons à votre message dans les plus brefs délais !</p>
          </div>
        </div>
        <div class="Contact-Form">
          <div class="Input-Side">
            <p class="Weight Input-Title">Prénom <strong class="asterix">*</strong></p>
            <div class="Input-Container">
              <img class="Icon-Id" src="/img/contact/id-card.svg" alt="Icon Id"/>
              <input @keyup="removeThisError('firstname')" v-model="form.firstname" id="firstname" type="text"
                     placeholder="Ecrivez-votre prénom">
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div class="Input-Side">
            <p class="Weight Input-Title ">Nom <strong class="asterix">*</strong></p>
            <div class="Input-Container">
              <img class="Icon-Id" src="/img/contact/id-card.svg" alt="Icon Id"/>
              <input @keyup="removeThisError('name')" v-model="form.name" id="name" type="text"
                     placeholder="Ecrivez-votre nom">
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div>
            <p class="Weight Input-Title">Email <strong class="asterix">*</strong></p>
            <div class="Input-Container">
              <img class="Icon-Email" src="/img/contact/e-mail.svg" alt="Icon Email"/>
              <input @keyup="removeThisError('email')" v-model="form.email" id="email" type="email"
                     placeholder="Ecrivez-votre email">
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div>
            <p class="Weight Input-Title">Téléphone</p>
            <div class="Input-Container">
              <img class="Icon-Email" src="/img/contact/e-mail.svg" alt="Icon Email"/>
              <input @keyup="removeThisError('phone')" v-model="form.phone" id="phone" type="tel"
                     placeholder="Ecrivez-votre numéro de téléphone">
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div>
            <p class="Weight Input-Title">Sujet <strong class="asterix">*</strong></p>
            <div class="Input-Container">
              <img class="Icon-Envelop" src="/img/contact/email.svg" alt="Icon Envoyer"/>
              <input @keyup="removeThisError('subject')" v-model="form.subject" id="subject" type="text"
                     placeholder="Ecrivez le sujet de votre message">
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div>
            <p class="Weight Input-Title">Message <strong class="asterix">*</strong></p>
            <div class="Input-Container">
              <img class="Icon-Envelop" src="/img/contact/email.svg" alt="Icon Envoyer"/>
              <textarea @keyup="removeThisError('message')" v-model="form.message" id="message" rows="20"
                        placeholder="Ecrivez-votre message">
                            </textarea>
            </div>
          </div>
          <div class="Contact--spacer"></div>
          <div>
            <p>
              Les champs marqués d'un astérisque (<strong class="asterix">*</strong>) sont obligatoires
            </p>
          </div>
          <div>
            <p id="Message"></p>
          </div>
          <div class="Contact--spacer"></div>
          <GoogleRecaptcha :token="form.token" :onChangeToken="v => form.token = v"></GoogleRecaptcha>
          <div class="Contact--spacer"></div>
          <div class="Contact--spacer"></div>
          <div @click="send" class="Contact--button">
            <Button>
              {{ loading ? 'Chargement...' : 'Envoyer' }}
            </Button>
          </div>
        </div>
      </div>
      <div class="Contact-GMaps">
        <img src="/img/contact/gmaps.png" alt="Maps"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HeadPageImage from '../global/HeadPageImage.vue'
import {apiPublicServerConfig} from "../../../../config/public/api.config";

export default {
  name: "Contact",
  components: {
    HeadPageImage
  },
  data() {
    return {
      /**
       * @type number
       */
      error: 0,
      /**
       * @type boolean
       */
      loading: false,
      /**
       * @type {{firstname: string, phone: string, subject: string, name: string, message: string, email: string, token: string}}
       */
      form: this.getForm()
    }
  },
  methods: {
    send() {
      this.removeError();
      document.getElementById('Message').classList.remove('Green');
      this.checkEmpty();
      this.checkRegex();
      if (this.error === 0) {
        this.loading = true
        this.sendEmail().then(() => {
          this.loading = false
          this.form = this.getForm();
        }).catch(() => {
          this.loading = false
        })
      }
    },
    checkEmpty() {
      for (const [key, value] of Object.entries(this.form)) {
        if (value == null || value.trim() === "") {
          if (!['phone', 'token'].includes(key)) {
            document.getElementById(key).classList.add('error');
            this.error = 1;
          }
        }
      }
      if (this.error === 1) {
        document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Des champs requis sont vides.'
      }
    },
    removeError() {
      this.error = 0;
      for (const [key, value] of Object.entries(this.form)) {
        if (value == null || value.trim() === "") {
          let el = document.getElementById(key)
          if (el) el.classList.remove('error');
        }
      }
      document.getElementById('Message').innerHTML = '';
    },
    removeThisError(id) {
      document.getElementById(id).classList.remove('error');
    },
    checkRegex() {
      const data = this.form
      const regexNames = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      const regexEmail = /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+$/;
      const regexPhone = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
      //Names
      if (!regexNames.test(data.firstname)) {
        this.error = 1;
        document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Votre prénom n\'est pas valide.';
      }
      if (!regexNames.test(data.name)) {
        this.error = 1;
        document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Votre nom n\'est pas valide.';
      }
      //Email
      if (!regexEmail.test(data.email)) {
        this.error = 1;
        document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Votre adresse Email n\'est pas valide.';
      }
      //Phone
      if (data.phone.length > 1) {
        if (!regexPhone.test(data.phone)) {
          this.error = 1;
          document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Votre numéro de téléphone n\'est pas valide.';
        }
      }
      //captcha
      if (!data.token) {
        this.error = 1;
        document.getElementById('Message').innerHTML = document.getElementById('Message').innerHTML + '<br>Vous devez valider le Recaptcha.';
      }
    },
    async sendEmail() {
      const {data} = await axios({
        method: 'POST',
        url: `${apiPublicServerConfig.protocol}://${apiPublicServerConfig.domain}:${apiPublicServerConfig.port}/api`,
        data: {
          "name": "customSendEmailContact",
          "scope": "default",
          "props": this.form
        }
      })
      if (data.success) {
        alert(`Votre message a bien été envoyé !`)
      } else {
        alert(`il y a eu un problème lors de l'envoi de votre e-mail, réessayer plus tard.`)
      }
    },
    /**
     * @returns {{firstname: string, phone: string, subject: string, name: string, message: string, email: string, token: string}}
     */
    getForm() {
      return {
        firstname: '',
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        token: '',
      }
    }
  }
}
</script>

<style scoped>

.Contact {

}

.Contact >>> .GoogleRecaptcha {
  display: flex;
  justify-content: center;
}

.Contact >>> .Button {
  max-width: 100px;
}

.Contact--button {
  display: flex;
  justify-content: center;
}

/* 
* Global
*/
a {
  color: #000000;
  text-decoration: none;
}

textarea {
  resize: none;
  width: 100%;
  box-sizing: border-box;
}

p, a {
  font-size: 16px;
}

.Contact-Container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  overflow: hidden;
}

.Contact-Content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
  padding-bottom: 100px;
  width: 100%;
}

.Contact-Content > div {
  margin-top: 50px;
}

.asterix, .error, #Message {
  color: red;
  border-color: red;
}

/* 
* Text 
*/
.Green {
  color: #00919B !important;
}

.Bold {
  font-family: 'GothamBold';
}

.Bold:nth-child(1) {
  font-size: 22px;
}

.Weight {
  font-weight: bold;
  margin-bottom: 5px;
}

.Top-Title {
  margin-bottom: 75px;
}

.Middle-Content {
  margin-bottom: 45px;
}

.Content-Adress {
  width: 34%;
}

.Bottom-Title {
  width: 70%;
  text-align: center;
}

.Bottom-Title img {
  width: 75px;
  margin-bottom: 20px;
}

/* 
* Form 
*/
.Contact-Form {
  background-color: #FFFFFF;
  border-radius: 15px;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
  padding: 40px 25px;
  width: 430px;
}

.Contact--spacer {
  height: 20px;
  min-height: 20px;
}

.Input-Title {
  color: #909090;
  padding-bottom: 10px;
}

input, textarea {
  padding: 20px 0px 20px 60px;
  margin-right: 20px;
  border-radius: 15px;
  border: 1px solid #707070;
  outline: none;
}

.Input-Container {
  position: relative;
}

.Input-Container img {
  position: absolute;
  width: 25px;
  left: 20px;
}

.Icon-Id {
  top: 18.5px;
}

.Icon-Email {
  top: 12.5px;
}

.Icon-Envelop {
  top: 19.5px;
}

.Input-Container input {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

/* 
* Maps 
*/
.Contact-GMaps, .Contact-GMaps img {
  width: 100%;
  display: block;
}

/* 
* Responsive
*/
@media (max-width: 1000px) {

  /*
  * Global
  */
  .Contact-Content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  .Contact-Data {
    text-align: center;
  }

  .Content-Adress, .Bottom-Title {
    margin-left: auto;
    margin-right: auto;
  }

  .Contact-Form {
    padding: 0 25px;
    box-sizing: border-box;
  }

  /*
  * Form
  */
  .Contact-Form {
    text-align: center;
    background-color: transparent;
    box-shadow: none;
    padding: 0 25px;
    width: 100%;
    box-sizing: border-box;
  }

  .Contact-Button {
    margin: auto;
  }

  .Input-Container img {
  }

  /*
  * Maps
  */
  .Contact-GMaps, .Contact-GMaps img {
    width: auto;
  }
}
</style>